import {Ref, computed} from 'vue';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribClass} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {CoreGroup} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Group';
import {attribClassClassObject, BuildHeaders, BuildTableData} from './Common';
import {
	vertices,
	vertexAttribNamesFromCoreGroup,
	vertexAttribSizesFromCoreGroup,
	vertexAttribTypesFromCoreGroup,
} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/entities/vertex/CoreVertexUtils';
import {CoreObjectType} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/ObjectContent';
import {CoreVertex} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/entities/vertex/CoreVertex';

interface SetupForVertexOptions {
	selectedAttribClass: Ref<AttribClass>;
	vertexAttribNames: Ref<string[]>;
	buildHeaders: BuildHeaders;
	buildTableData: BuildTableData;
}

export function SetupForVertex(options: SetupForVertexOptions) {
	const {selectedAttribClass, vertexAttribNames, buildHeaders, buildTableData} = options;

	const classObjectVertexButton = computed(() => {
		return attribClassClassObject(selectedAttribClass.value == AttribClass.VERTEX);
	});
	function setAttribClassVertex() {
		selectedAttribClass.value = AttribClass.VERTEX;
	}

	//
	//
	// POINTS
	//
	//
	const _vertices: CoreVertex<CoreObjectType>[] = [];
	function build(coreGroup: CoreGroup) {
		vertexAttribNames.value = vertexAttribNamesFromCoreGroup(coreGroup);
		const attrib_sizes = vertexAttribSizesFromCoreGroup(coreGroup);
		const attrib_types_by_name: PolyDictionary<AttribType> = {};
		const attribTypes = vertexAttribTypesFromCoreGroup(coreGroup);
		for (let name of vertexAttribNames.value) {
			const type = attribTypes[name];
			if (type) {
				attrib_types_by_name[name] = type;
			}
		}
		buildHeaders(vertexAttribNames.value, attrib_sizes, attrib_types_by_name);
		buildTableData(vertices(coreGroup, _vertices), vertexAttribNames.value, attrib_sizes);
	}

	return {
		classObjectVertexButton,
		setAttribClassVertex,
		build,
	};
}
